import { TitleWithBody } from '../types/new-car-offers'

/**
 * The content here is formatted in the same way as the parsed JSON that comes back from Storyblok.
 * I decided to structure it in this way for parity with the other landing content driven pages, and so it's ewasier to swap storyblok in later on when we have more time
 */
export const INTRO_CONTENT: TitleWithBody = {
  title: 'Why buy from Marshall Motor Group?',
  body: {
    type: 'doc',
    content: [
      {
        type: 'paragraph',
        content: [
          {
            text: 'Marshall and cinch are both part of Constellation Automotive Group, the largest vertically integrated digital car marketplace in Europe.',
            type: 'text',
          },
        ],
      },
      {
        type: 'paragraph',
        content: [
          {
            type: 'hard_break',
          },
          {
            text: 'One of the UK’s largest dealer networks, Marshall operates from 138 stores across 34 counties, representing 25 leading automotive brands.',
            type: 'text',
          },
        ],
      },
      {
        type: 'paragraph',
        content: [
          {
            type: 'hard_break',
          },
          {
            text: 'Marshall has been operating for over 115 years and sells new and used cars, motorcycles and vans, with flexible finance options and nationwide delivery.',
            type: 'text',
          },
        ],
      },
      {
        type: 'paragraph',
        content: [
          {
            type: 'hard_break',
          },
          {
            text: 'Marshall stores also provide expert servicing, MOT preparation and accident repairs, all backed by manufacturers such as BMW, Audi and Volkswagen.',
            type: 'text',
          },
        ],
      },
    ],
  },
}
